import React, {Component}from "react";

// Assets
import PlusIcon from "../../Assets/plus.svg";
import MinusIcon from "../../Assets/minus.svg";
import LeftArrowIcon from "../../Assets/leftArrow.svg";
import RightArrowIcon from "../../Assets/rightArrow.svg";

// MedicalInfo   Component
export default class MedicalInfo extends Component {
  // constructor function
  constructor(props) {
    super(props);

    this.state = {
      // state to store user medical information
      heightCnt: 10,
      weightCnt: 10,
      bloodGroup: "AB",
      bloodGroupList: ["AB", "A", "B", "O"],
      cnt: 0,
    };
  }

  // function to increment height or weight & change blood group
  valueIncrement(inputType) {
    // increment height
    if (inputType === 1) {
      let newValue = 1 + this.state.heightCnt;

      if (this.state.heightCnt >= 0) this.setState({ heightCnt: newValue });

      // increment weight
    } else if (inputType === 2) {
      let newValue = 1 + this.state.weightCnt;

      if (this.state.weightCnt >= 0) this.setState({ weightCnt: newValue });

      // change blood group
    } else {
      if (this.state.cnt >= 0 && this.state.cnt < 3) {
        let newValue = 1 + this.state.cnt;

        this.setState({
          cnt: this.state.cnt + 1,
          bloodGroup: this.state.bloodGroupList[newValue],
        });
      }
    }
  }

  // function to decrement height or weight & change blood group
  valueDecrement(inputType) {
    // decrement height
    if (inputType === 1) {
      let newValue = this.state.heightCnt - 1;

      if (this.state.heightCnt >= 0) this.setState({ heightCnt: newValue });

      // decrement weight
    } else if (inputType === 2) {
      let newValue = this.state.weightCnt - 1;

      if (this.state.weightCnt >= 0) this.setState({ weightCnt: newValue });

      // change blood group
    } else {
      if (this.state.cnt > 0 && this.state.cnt <= 3) {
        let newValue = this.state.cnt - 1;

        this.setState({
          cnt: this.state.cnt - 1,
          bloodGroup: this.state.bloodGroupList[newValue],
        });
      }
    }
  }

  // inputType = 1 is for height counter, inputType = 2 is for weight counter & inputType 3 is for Blood Group
  medicalParaCards(inputType, cardTitle, count, para) {
    return (
      <div className="Profile_MICard">
        <div className="Profile_CardTitle">{cardTitle}</div>
        <div className="Profile_CardData">
          <div className="Profile_CountData">{count}</div>
          <div className="Profile_CountParameter">{para}</div>
        </div>

        {/* Condition for button change*/}
        {inputType === 1 || inputType === 2 ? (
          <div className="Profile_MICard_Buttons">
            <button
              className="Profile_MILeftButton"
              style={{ backgroundImage: `url(${MinusIcon})` }}
              onClick={() => {
                this.valueDecrement(inputType);
              }}
            ></button>

            <button
              className="Profile_MIRightButton"
              style={{ backgroundImage: `url(${PlusIcon})` }}
              onClick={() => {
                this.valueIncrement(inputType);
              }}
            ></button>
          </div>
        ) : (
          <div className="Profile_MICard_Buttons">
            <button
              className="Profile_MILeftButton"
              style={{ backgroundImage: `url(${LeftArrowIcon})` }}
              onClick={() => {
                this.valueDecrement(inputType);
              }}
            ></button>
            <button
              className="Profile_MIRightButton"
              style={{ backgroundImage: `url(${RightArrowIcon})` }}
              onClick={() => {
                this.valueIncrement(inputType);
              }}
            ></button>
          </div>
        )}
      </div>
    );
  }

  render() {
    return (
      <div className="Profile_MedicalInfo_Component">
        <div className="Profile_MITitle">Medical Information</div>

        <div className="Profile_MIBlock">
          {this.medicalParaCards(1, "Set Height", this.state.heightCnt, "cm")}
          {this.medicalParaCards(2, "Set Weight", this.state.weightCnt, "Kg")}
          {this.medicalParaCards(
            3,
            "Set Blood Group",
            this.state.bloodGroup,
            "+"
          )}
        </div>
      </div>
    );
  }
}
